export enum PermissionType {
  TRNS = 'TRNS',
}
